/** Navigation targets never grant authority. Each destination independently verifies its reads. */
export const headquartersPages = [
  { id: 'dashboard', label: '본사 대시보드', shortLabel: '대시보드' },
  { id: 'halfyear', label: '중처법 관리 (반기점검)', shortLabel: '중처법 관리' },
  { id: 'emphasis', label: '안전강조주간', shortLabel: '안전강조주간' },
  { id: 'meetings', label: '안전보건 월회의', shortLabel: '월회의' },
  { id: 'inspections', label: '본사 지도점검', shortLabel: '본사 지도점검' },
  { id: 'accidents', label: '안전사고 현황', shortLabel: '사고 현황' },
  { id: 'sites', label: '사업장 연결', shortLabel: '사업장 연결' },
  { id: 'library', label: '자료실', shortLabel: '자료실' },
] as const;

/** Dashboard destinations remain available; standalone HQ menus show the five core duties. */
export const headquartersNavigationPages = headquartersPages.filter(
  page => !['accidents', 'sites', 'library'].includes(page.id),
);

export type HeadquartersPage = (typeof headquartersPages)[number]['id'];

export function headquartersPagePath(page: HeadquartersPage): string {
  return page === 'dashboard' ? '/headquarters' : `/headquarters/${page}`;
}

export function headquartersPageForPath(path: string): HeadquartersPage | null {
  return headquartersPages.find(page => headquartersPagePath(page.id) === path.replace(/\/$/u, ''))?.id ?? null;
}
